import { useUser } from '../../../../context/UserContext'
import useWindowDimensions from '../../../../hooks/getWindowDimensions'
import ChartDataIcon from '../../../../icon/ChartDataIcon'
import ChartMaximumIcon from '../../../../icon/ChartMaximumIcon'
import DollarCoinIcon from '../../../../icon/DollarCoinIcon'
import UsersIcon from '../../../../icon/UsersIcon'
import ListTooltip from '../../../../ui/ListTooltip/ListTooltip'
import { formatNumber } from '../../../../utilities/functions'
import Card from '../../../Card/Card'
import classes from './Stats.module.css'


const Stats = () => {
    const {user} = useUser()
     const { height, width } = useWindowDimensions();

    const stats = [
        {   icon: <DollarCoinIcon />,
            amount: `$${user.trackingStatistics?.balance ? formatNumber(user.trackingStatistics?.balance) : 0}`,
            name: "Balance",
            info: "This section displays your total balance after all trades have been closed, reflecting both profits and losses"
        },
        {   icon: <ChartDataIcon />,
            amount: `$${user.trackingStatistics ? formatNumber(user.trackingStatistics?.statistics?.profitLoss) : 0}`,
            name: "Profit/Loss",
            info: "This section displays the overall profit or loss from your closed trades. It updates automatically with each closed trade, showing your most recent results."
        },
        {   icon: <ChartMaximumIcon />,
            amount: `$${user.trackingStatistics ? formatNumber(user.trackingStatistics?.statistics?.drawdown) : 0}`,
            name: "Drawdown",
            info: "This section shows the current drawdown from losing trades in your account."
        },
        {   icon: <UsersIcon />,
            amount: "No",
            name: "Group Trading",
            info: "Coordinated trading where a group of traders shares signals and strategies, replicating each other's trades to boost collective profits."
        }
    ]
    return(
        <div className={`${classes.statsContainer} ${width <= 768 ? classes.scrollable : "row"}`}>
            {stats.map((item, i) => (<div className={`${classes.cardWrapper} ${width <= 768 ? "" : "col-3"}`} key={i}>
                <Card className={classes.statsCard}>
                    <div className='mb-4'>
                    {item.icon}
                    </div>
                <h4>{item.amount}</h4>
                <ListTooltip className={classes.nameText} text={item.name} info={item.info} index={i}/>
                </Card>
            </div>))}
        </div>
    )
}

export default Stats